/*
 * @Author: pengzhihui
 * @Description:
 * @Date: 2020-08-27 22:11:47
 */
// import { cloneDeep } from "lodash";


function cloneDeep(o: any) {
    return JSON.parse(JSON.stringify(o));
}

let globalState: Record<string, any> = {};

type Callback = any;

const deps: Record<string, Callback> = {};

const fireEvent = (
    state: Record<string, any>,
    prevState: Record<string, any>
) => {
    Object.keys(deps).forEach((id: string) => {
        if (deps[id] instanceof Function) {
            deps[id](cloneDeep(state), cloneDeep(prevState));
        }
    });
};

export const initGlobalState = (
    coreId: number,
    initalState: Record<string, any>
) => {
    if (globalState === initalState) {
        console.warn("[DOLLY] global state is not changed!");
    } else {
        const prevGlobalState = cloneDeep(globalState);
        globalState = cloneDeep(initalState);
        fireEvent(globalState, prevGlobalState);
    }

    return getStateActions(`DOLLY-${coreId}`, true);
};

export const getStateActions = (key: string, isInit: boolean): any => {
    return {
        onGlobalStateChange: (callback: any): boolean => {
            if (!(callback instanceof Function)) {
                console.error("[DOLLY] callback must be function!");
                return false;
            }
            if (deps[key]) {
                console.warn(
                    `[DOLLY] a gloabal listener already exists, new listener will overwrite.`
                );
            }
            deps[key] = callback;
            return true;
        },
        setGlobalState: (state: Record<string, any>): boolean => {
            if (state === globalState) {
                console.warn("[DOLLY] global state is not changed!");
                return false;
            }

            const changeKeys: string[] = [];
            const prevGloabalState = cloneDeep(globalState);
            globalState = cloneDeep(
                Object.keys(state).reduce((_gloabalState, changeKey) => {
                    // 设置的全局状态
                    if (!isInit && !_gloabalState.hasOwnProperty(changeKey)) {
                        console.warn(
                            `[DOLLY] '${changeKey}' not declared in init state！`
                        );
                        return _gloabalState;
                    } else {
                        changeKeys.push(changeKey);
                        return Object.assign(_gloabalState, {
                            [changeKey]: state[changeKey],
                        });
                    }
                }, globalState)
            );

            if (changeKeys.length === 0) {
                return false;
            }
            fireEvent(globalState, prevGloabalState);
            return true;
        },
        offGlobalStateListen: (): boolean => {
            if (deps[key]) {
                delete deps[key];
            }
            return true;
        },
    };
};
